import React from 'react';
import { Button, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ButtonAction from './ButtonAction';

export default class OrgAssetModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selected: [],
    };
  }

  getOrgAssets() {
    return this.props.orgAssets || [];
  }

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  }

  handleChange = (e, id) => {
    const newSelected = this.state.selected;
    if (e.target.checked) {
      newSelected.push(id);
    } else {
      const index = this.state.selected.indexOf(id);
      if (index > -1) {
        newSelected.splice(index, 1);
      }
    }
    this.setState({
      selected: newSelected,
    });
  }

  submitForm = () => {
    if (this.state.selected.length > 0) {
      this.props.addOrgAssets(this.state.selected);
    }
    this.toggle();
  }

  listItemClass(asset) {
    let className = 'list-group-item';
    if (asset.disabled) { className += ' disabled'; }
    return className;
  }

  render() {
    return (<div>
      <Button title="Add organization files to project" color="secondary" onClick={this.toggle}>
        Add Organization Files
      </Button>
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        ref="OrgAssetsModal"
      >
        <ModalHeader>
          Organization Assets
        </ModalHeader>
        <ModalBody>
          <ul className="list-group">
            {this.getOrgAssets().map((asset, index) =>
              (<li
                key={index}
                className={this.listItemClass(asset)}
              >
                <Label check>
                  <Input
                    onChange={e => this.handleChange(e, asset.id)}
                    type="checkbox"
                    disabled={asset.disabled}
                  />{' '}
                  {asset.name} {asset.type}
                </Label>
              </li>),
            )}
          </ul>
        </ModalBody>
        <ModalFooter>
          <ButtonAction
            action={this.submitForm}
            color="success"
          >
            Save
          </ButtonAction>
          <Button
            color="info"
            onClick={this.toggle}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>);
  }

}
